import React from 'react';
import CustomTypography from '../../CustomTypography/CustomTypography';
import useStyles from './CustomStepperTrackingTooltipStyle';
var CustomStepperTrackingTooltip = function (_a) {
    var className = _a.className, modeloStep = _a.modeloStep;
    var styles = useStyles();
    return (React.createElement("section", { className: className },
        React.createElement("section", { className: styles.tooltipCnt },
            React.createElement("div", { className: styles.flechaTooltip }),
            React.createElement("section", { className: styles.tooltip },
                React.createElement("div", { className: styles.tooltipItem },
                    React.createElement(CustomTypography, { strong: "normal", variant: "label" }, modeloStep.textoTooltip))))));
};
export default CustomStepperTrackingTooltip;
